import angular from 'angular';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { AncillariesService } from '../../../components/ib-web-ancillaries/ib-web-ancillaries-service';
import { DatalayerConstantsType } from 'ib-web-commons/app/core/ib-datalayer/ib-datalayer-constants';
import {CommonsConstantsType} from 'ib-web-commons/constants/ib-commons-constants';
const controllerInfo = {
    module: 'ib-onrequest-flexibilization-module',
    inject: [
        'object',
        '$uibModalInstance',
        'localStorageService',
        'CurrencyService',
        'NewMainHeaderFacade',
        'ModalServiceAncillaries',
        'AncillariesConstants',
        'CommonsAncillariesService',
        'DatalayerUtilsService',
        '$filter',
        'DatalayerUtils',
        'AncillariesService',
        '$rootScope',
        'CommonsConstants',
        'CommonsUtilService',
        'DatalayerConstants'
    ],
    required: []
};
export class FlexibilizationController {
    public model: AncillariesModel.FlexibilityModel = this.object.model;
    public voucherRefundAncillarie = false;
    public flightChangeAncillarie = false;
    public flexibilityPackAncillarie = false;
    public showFirst = false;
    public showSecond = false;
    public showThird = false;
    public showTotal = false;
    public showPartial = false;
    public showPackFlex = false;
    public discountPackFlex = 0;
    public discountTextPackFlex = '';
    public TEXT_1 = '';
    public TEXT_2 = '';
    public TEXT_3 = '';
    public totalFormatted: string;
    public showModalAvios : boolean = false;

    constructor (
        private object: { model: AncillariesModel.FlexibilityModel },
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CurrencyService: CurrencyService,
        private NewMainHeaderFacade: any,
        private ModalServiceAncillaries: any,
        private AncillariesConstants: AncillariesConstant,
        private CommonsAncillariesService: CommonsAncillariesService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private $filter: angular.FilterFactory,
        private DatalayerUtils: DatalayerUtils,
        private AncillariesService:AncillariesService,
        private $rootScope: CommonsRootScope,
        private CommonsConstants: CommonsConstantsType,
        private CommonsUtilService: CommonsUtilService,
        private DatalayerConstants: DatalayerConstantsType
    ) {
        this.active();
    }

    active = () => {
        const selectedFlex: AncillariesModel.AncillaryInfo = this.localStorageService.get('selectedFlex');
        selectedFlex ? this.selectFlex(selectedFlex) : this.selectFlex(null);
        this.checkFlex(selectedFlex);
        this.checkAvailabilityAncillarie();
        this.buildLitAndHtml();
        this.showModalAvios = this.localStorageService.get('genAviosAncillariesFlex') !== null;
    };

    checkAvailabilityAncillarie = () => {
        angular.forEach(this.model.info, (info, index) => {
            if (info.subtype === 'VOUCHER_REFUND' && info.status.code === 'AVAILABLE') {
                this.voucherRefundAncillarie = true;
                if (info.percentage < 100) {
                    this.showPartial = true;
                    this.showTotal = false;
                } else if (info.percentage >= 100) {
                    this.showPartial = false;
                    this.showTotal = true;////////
                }
            }
            if (info.subtype === 'FLIGHT_CHANGE' && info.status.code === 'AVAILABLE') {
                this.flightChangeAncillarie = true;
            }
            if (info.subtype === 'FLEXIBILITY_PACK' && info.status.code === 'AVAILABLE') {
                this.flexibilityPackAncillarie = true;
            }
        });

        if (this.voucherRefundAncillarie === true &&
            this.flightChangeAncillarie === false) {
            this.showFirst = true;///////
        } else if (this.voucherRefundAncillarie === false &&
            this.flightChangeAncillarie === true) {
            this.showSecond = true;
        } else if (this.voucherRefundAncillarie === true &&
            this.flightChangeAncillarie === true) {
            this.showSecond = true;
        }
        if (this.voucherRefundAncillarie === true &&
            this.flightChangeAncillarie === false &&
            this.flexibilityPackAncillarie === false ) {
            this.showFirst = false;
            this.showSecond = false;
            this.showThird = true;
        }

    };

    checkFlex = (selectedFlex) => {
        let flightChangeExist = false, voucherRefoundExist = false;
        this.showPackFlex = false;

        if (this.model) {
            if (selectedFlex) {
                angular.forEach(this.model.info, (info, index) => {
                    if (info.subtype === selectedFlex.subtype) {
                        this.model.selectedFlex = this.model.info[index];
                    }
                    if (info.subtype === 'FLIGHT_CHANGE') {
                        flightChangeExist = true;
                    } else if (info.subtype === 'VOUCHER_REFUND') {
                        voucherRefoundExist = true;
                    }
                });
                if (flightChangeExist && voucherRefoundExist) {
                    this.showPackFlex = true;
                }
            } else {
                this.model.selectedFlex = null;
            }
            angular.forEach(this.model.info, (info, index) => {
                if (info.subtype === 'FLIGHT_CHANGE') {
                    flightChangeExist = true;
                } else if (info.subtype === 'VOUCHER_REFUND') {
                    voucherRefoundExist = true;
                }
                if (info.subtype === 'PACK_FLEX') {
                    this.discountPackFlex = info.discount;
                    this.discountTextPackFlex = this.$filter('translate')('ANCILLARIES_FLEXIBILITY_SAVE_PERCENTAGE').replace('XX', this.discountPackFlex);
                }
            });
            if (flightChangeExist && voucherRefoundExist) {
                this.showPackFlex = true;
            }
        }
    };
    updateDataLayerAndDigitalData = (): void => {
        const flow = this.localStorageService.get('flowApp');
        let quadrigam = '';
        switch (flow) {
                case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                    quadrigam = this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase();
                    break;
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    quadrigam = this.AncillariesConstants.QUADRIGAM.ANCILLARIES;
                    break;
        }
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, quadrigam);
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
    };

    close = () => {
        const flow = this.localStorageService.get('flowApp');
        this.$uibModalInstance.dismiss();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    };

    selectFlex = (flex: AncillariesModel.AncillaryInfo) => {
        const currency: CommonsCurrencyModel.CurrencyResponse = this.localStorageService.get('currency');
        if (flex) {
            this.totalFormatted = this.CurrencyService.formatPrice(currency, flex.total, true, false);
            this.DatalayerUtils.setFlexibilizationSelectItem(flex);
            this.AncillariesService.getAviosAncillariesFlex(flex);
            this.localStorageService.set('selectedFlex', this.model.selectedFlex);
            this.showModalAvios = true;
        } else {
            this.totalFormatted = this.CurrencyService.formatPrice(currency, 0, true, false);
        }
    };

    accept = () => {
        const flow = this.localStorageService.get('flowApp');
        const selectedFlex: AncillariesModel.AncillaryInfo = this.localStorageService.get('selectedFlex'), deleteInfo = [{
            type: this.AncillariesConstants.TYPE_ANCILLARIE.FLEXIBILITY
        }];
        if (this.model.selectedFlex) {
            const update = [{
                type: this.AncillariesConstants.TYPE_ANCILLARIE.FLEXIBILITY,
                subtype: this.model.selectedFlex.subtype
            }];
            this.ModalServiceAncillaries.showWaitingModal();
            this.CommonsAncillariesService.updateAncillaries(update).then((data) => {
                this.model.confirmed = true;

                this.ModalServiceAncillaries.isNotWaiting();
            }, (error) => {
                this.model.confirmed = false;
                this.model.selectedFlex = null;
                this.ModalServiceAncillaries.isNotWaiting();
                this.ModalServiceAncillaries.showGenericError(error).result.then(angular.noop, angular.noop);
            });

        } else {
            if (selectedFlex) {

                this.ModalServiceAncillaries.showWaitingModal();
                this.CommonsAncillariesService.deleteAncillarie(deleteInfo).then((data) => {
                    this.model.confirmed = false;
                    this.model.selectedFlex = null;
                    this.ModalServiceAncillaries.isNotWaiting();
                }, (error) => {
                    this.ModalServiceAncillaries.isNotWaiting();
                    this.ModalServiceAncillaries.showGenericError(error).result.then(angular.noop, angular.noop);
                });
            }
        }
        this.DatalayerUtils.setFlexibilizationAddToCart(this.model.selectedFlex);
        this.DatalayerUtilsService.updateDatalayerActionForAncillaries(
            this.AncillariesConstants.DATALAYER_INFO.FLEXIBILIZATION_CONFIRM,
            this.AncillariesConstants.DATALAYER_INFO.CLICK,
            this.AncillariesConstants.DATALAYER_INFO.CONFIRM
        );
        this.NewMainHeaderFacade.updateBasketFlexibilization(this.model.selectedFlex);
        this.localStorageService.set('selectedFlex', this.model.selectedFlex);
        this.$uibModalInstance.dismiss();
        const ancillariesFlex = this.localStorageService.get('genAviosAncillariesFlex');
        this.AncillariesService.getAviosAncillariesSummaryReq(
            ancillariesFlex,
            this.AncillariesConstants.TYPE_ANCILLARIE.FLEXIBILITY
        );
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    };

    /**
     * Open modal for show know more information
     * @param {String} description Name of piece selected
     * @param {String} subtype Type of piece selected
     */
    openFlexKnowMoreInformation = (flag: string, percentage: number) => {
        if (flag === 'refound') {
            this.ModalServiceAncillaries.openFlexInformation({ template: 'ib-modal-flexibilization-know-more', percentage: percentage });
        } else {
            this.ModalServiceAncillaries.openFlexInformation({ template: 'ib-modal-flex-change-flight-know-more', percentage: null });
        }
    };

    buildLitAndHtml = () => {
        const tagsInfo = {
            bold: {
                tag: 'span',
                class: 'ib-text ib-text--inline ib-text--bold ib-text--italic ib-text--color-unfocused ib-text--small'
            }
        };
        const LITERALS = {
            TEXT_1: 'ANCILLARIES_FLEXIBILITY_FLIGHT_CHANGE_DESCRIPTION',
            TEXT_2: 'ANCILLARIES_FLEXIBILITY_VOUCHER_REFUND_CHANGE_DESCRIPTION',
            TEXT_3: 'ANCILLARIES_FLEXIBILITY_CHOSE_ONE'
        };
        this.TEXT_1 = this.$filter('literalFormatter')(this.$filter('translate')(LITERALS.TEXT_1), tagsInfo);
        this.TEXT_2 = this.$filter('literalFormatter')(this.$filter('translate')(LITERALS.TEXT_2), tagsInfo);
        this.TEXT_3 = this.$filter('literalFormatter')(this.$filter('translate')(LITERALS.TEXT_3), tagsInfo);
    };

    /**
     * open modal avios flex
     */
    openModalAviosFlexAncillaries = (): void => {
        this.AncillariesService.manageAviosModal(this.localStorageService.get('genAviosAncillariesFlex'));
    };

}

try {
    FlexibilizationController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(FlexibilizationController.name, FlexibilizationController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    FlexibilizationController.$inject = controllerInfo.inject;
    mod.controller(FlexibilizationController.name, FlexibilizationController);
}